<template>
  <div
    class="i-quiz-interstitial"
    :class="{ show: visible }"
  >
    <div class="spinner"></div>
    <div class="msg">{{ message }}</div>
  </div>
</template>

<script setup>
defineProps({
  visible: Boolean,
  message: { type: String, default: "Processing your results..." }
})
</script>

<style lang="scss" scoped>
.i-quiz-interstitial {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: $white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;

  &.show {
    opacity: 1;
    pointer-events: auto;
  }

  .spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #1118271a;
    border-top-color: $amber-mid;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 18px;

    @include respond-to($breakpoint-md) {
      width: 40px;
      height: 40px;
    }
  }

  .msg {
    font-family: $serif;
    font-size: 20px;
    color: #111827cc;
    text-align: center;
    padding: 0 24px;

    @include respond-to($breakpoint-md) {
      font-size: 22px;
    }
  }
}
</style>
